import Vue from 'vue'
import Router from 'vue-router'
// import Hello from '@/components/Hello'
import Single from '@/components/Layouts/Single.vue'
import Dual from '@/components/Layouts/Dual.vue'

Vue.use(Router)

let desktopStarMobilePlain = window.innerWidth >= 1439 ? require('@/components/Scenes/StarSkyBg/StarSkyBg.vue').default : require('@/components/Scenes/Spiral/SpiralVase.vue').default
desktopStarMobilePlain = require('@/components/Scenes/Spiral/SpiralVase.vue').default

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
        // , offset: { x: 0, y: 10 }
      }
    }
    return new Promise((resolve, reject) => {
      Vue.prototype.$nextTick(() => {
        resolve({ x: 0, y: 0 })
      })
    })
  },
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'Hello',
    //   component: Hello
    // },
    // {
    //   path: '/',
    //   component: Single
    // },
    {
      path: '/single',
      component: Single
    },
    {
      path: '/',
      component: Dual,
      children: [
        {
          path: '',
          components: {
            webgl: require('@/components/Scenes/StarSkyBg/StarSkyBg.vue').default,
            dom: require('@/components/Pages/Landing/Landing.vue').default
          }
        },
        {
          path: 'game-start',
          components: {
            webgl: require('@/components/Scenes/Spiral/SpiralVase.vue').default,
            dom: require('@/components/Pages/GameStart/GameStart.vue').default
          }
        },
        {
          path: 'choose-photo',
          components: {
            webgl: desktopStarMobilePlain,
            dom: require('@/components/Pages/ChoosePhoto/ChoosePhoto.vue').default
          }
        },
        {
          path: 'choose-photo/adjust-photo',
          components: {
            webgl: desktopStarMobilePlain,
            dom: require('@/components/Pages/ChoosePhoto/ChoosePhoto.vue').default
          }
        },
        {
          path: 'choose-photo/take-photo',
          components: {
            webgl: desktopStarMobilePlain,
            dom: require('@/components/Pages/ChoosePhoto/ChoosePhoto.vue').default
          }
        },
        {
          path: 'define-radiance',
          components: {
            webgl: desktopStarMobilePlain,
            dom: require('@/components/Pages/DefineRadiance/DefineRadiance.vue').default
          }
        },
        {
          path: 'data-form',
          components: {
            webgl: desktopStarMobilePlain,
            dom: require('@/components/Pages/DataForm/DataForm.vue').default
          }
        },
        {
          path: 'unlock',
          components: {
            webgl: require('@/components/Scenes/Spiral/SpiralVortex.vue').default,
            dom: require('@/components/Pages/Unlock/Unlock.vue').default
          }
        },
        {
          path: 'share-page',
          components: {
            webgl: require('@/components/Scenes/StarSkyBg/StarSkyBg.vue').default,
            dom: require('@/components/Pages/SharePage/SharePage.vue').default
          }
        },
        {
          path: 'kids-wishes',
          components: {
            webgl: require('@/components/Scenes/Spiral/SpiralVase.vue').default,
            dom: require('@/components/Pages/KidsWishes/KidsWishes.vue').default
          }
        },
        {
          path: 'radiance-set',
          components: {
            webgl: require('@/components/Scenes/Spiral/SpiralVase.vue').default,
            dom: require('@/components/Pages/RadianceSet/RadianceSet.vue').default
          }
        },
        {
          path: 'about',
          components: {
            webgl: require('@/components/Scenes/Spiral/SpiralVase.vue').default,
            dom: require('@/components/Pages/About/About.vue').default
          }
        },
        {
          path: 'toc',
          components: {
            webgl: require('@/components/Scenes/Spiral/SpiralVase.vue').default,
            dom: require('@/components/Pages/TOC/TOC.vue').default
          }
        },
        {
          path: 'privacy',
          components: {
            webgl: require('@/components/Scenes/Spiral/SpiralVase.vue').default,
            dom: require('@/components/Pages/Privacy/Privacy.vue').default
          }
        },
        {
          path: 'demo/remixer',
          components: {
            webgl: require('@/components/Scenes/Spiral/SpiralVortexRemixer.vue').default,
            dom: require('@/components/Pages/KeyRemixer/KeyRemixer.vue').default
          }
        },
        {
          path: 'demo/remixer2',
          components: {
            webgl: require('@/components/Scenes/StarSkyBg/StarSkyBgRemixer.vue').default,
            dom: require('@/components/Pages/KeyRemixer/KeyRemixer.vue').default
          }
        }// ,

        // demos
        // {
        //   path: 'photo-camera',
        //   components: {
        //     webgl: () => import('@/components/Scenes/Empty/Empty.vue'),
        //     dom: () => import('@/components/Pages/PhotoCamera/PhotoCamera.vue')
        //   }
        // },
        // {
        //   path: 'key',
        //   components: {
        //     webgl: () => import('@/components/Scenes/KeyFunz/KeyFunz.vue'),
        //     dom: () => import('@/components/DOM/Empty/Empty.vue')
        //   }
        // },
        // {
        //   path: 'adjuster',
        //   components: {
        //     webgl: () => import('@/components/Scenes/Empty/Empty.vue'),
        //     dom: () => import('@/components/Pages/Adjuster/Adjuster.vue')
        //   }
        // },
        // {
        //   path: 'same-webgl-different-dom',
        //   components: {
        //     webgl: () => import('@/components/Scenes/StarSkyBg/StarSkyBg.vue'),
        //     dom: () => import('@/components/Pages/Happy/Happy.vue')
        //   }
        // },
        // {
        //   path: 'vase',
        //   components: {
        //     webgl: () => import('@/components/Scenes/Spiral/SpiralVase.vue'),
        //     dom: () => import('@/components/Pages/Spiral/Spiral.vue')
        //   }
        // },
        // {
        //   path: 'vortex',
        //   components: {
        //     webgl: () => import('@/components/Scenes/Spiral/SpiralVortex.vue'),
        //     dom: () => import('@/components/Pages/Spiral/Spiral.vue')
        //   }
        // },
        // {
        //   path: 'shooting-stars',
        //   components: {
        //     webgl: () => import('@/components/Scenes/ShootingStars/ShootingStars.vue'),
        //     dom: () => import('@/components/Pages/Spiral/Spiral.vue')
        //   }
        // },
        // {
        //   path: '',
        //   components: {
        //     webgl: () => import('@/components/Scenes/Home/Home.vue'),
        //     dom: () => import('@/components/Pages/Home/Home.vue')
        //   }
        // },
        // {
        //   path: 'happy',
        //   components: {
        //     webgl: () => import('@/components/Scenes/Happy/Happy.vue'),
        //     dom: () => import('@/components/Pages/Happy/Happy.vue')
        //   }
        // },

        // {
        //   path: 'bally',
        //   components: {
        //     webgl: () => import('@/components/Scenes/Sky/Sky.vue'),
        //     dom: () => import('@/components/Pages/Happy/Happy.vue')
        //   }
        // },

        // // Cachers
        // {
        //   path: 'cache/StarSkyBg',
        //   beforeEnter (to, from, next) {
        //     if (from.meta && from.meta.cache) {
        //       next()
        //     } else {
        //       next('/')
        //     }
        //   },
        //   components: {
        //     webgl: () => import('@/components/Scenes/StarSkyBg/StarSkyBg.vue'),
        //     dom: () => import('@/components/DOM/Empty/Empty.vue')
        //   }
        // },
        // {
        //   path: 'cache/SpiralVortex',
        //   beforeEnter (to, from, next) {
        //     if (from.meta && from.meta.cache) {
        //       next()
        //     } else {
        //       next('/')
        //     }
        //   },
        //   components: {
        //     webgl: () => import('@/components/Scenes/Spiral/SpiralVortex.vue'),
        //     dom: () => import('@/components/DOM/Empty/Empty.vue')
        //   }
        // },
        // {
        //   path: 'cache/SpiralVase',
        //   beforeEnter (to, from, next) {
        //     if (from.meta && from.meta.cache) {
        //       next()
        //     } else {
        //       next('/')
        //     }
        //   },
        //   components: {
        //     webgl: () => import('@/components/Scenes/Spiral/SpiralVase.vue'),
        //     dom: () => import('@/components/DOM/Empty/Empty.vue')
        //   }
        // }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js